
import { Component, Vue } from "vue-property-decorator";
import General from "@/components/Noticias/General.vue";

@Component({
  components: {
    General
  },
  meta: {
    // sets document title
    title: "Noticias - Municipalidad de Maipú",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Revisa aquí las últimas noticias de la comuna."
      },
      keywords: { name: "keywords", content: "Maipú" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class NoticiasView extends Vue {
  private mounted() {
    document.title = "Noticias - Municipalidad de Maipú";
  }
}
